import cn from 'classnames/bind';
import Image from "next/legacy/image";
import PropTypes from 'prop-types';
import {
  Container, Col, Row, WithAspect, Text,
} from 'ui';

import s from './FamousPersonsSection.module.scss';

const cx = cn.bind(s);

const FamousPersonsSection = ({
  className, type, persons = [], ...attrs
}) => (
  <Container className={cx(className, 'section')} {...attrs}>
    <h2 className={cx('sectionTitle', 'xl:tp-header-2', 'tp-tablet-header-2')}>
      {type} you may know
    </h2>
    <Row className={cx('personsRow')}>
      {persons.map((person) => (
        <Col key={person.slug} className={cx('personCol')} lg={{ offset: 0, span: 4 }} md={{ offset: 3, span: 6 }} xs={12}>
          <WithAspect aspect={355 / 345}>
            <Image src={`/images/persons/${person.slug}.svg`} alt={person.name} layout="fill" />
          </WithAspect>
          <Text as="h3" tag="p" className={cx('personName')} center>
            { person.name }
          </Text>
        </Col>
      ))}
    </Row>
  </Container>
);

FamousPersonsSection.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default FamousPersonsSection;
